import { CallAPI } from "../../apiManager/ApiCall";
import { aiGenerateQuestionURL } from "../../apiManager/APIConfig";

/**
 * Generate a quiz question suggestion using AI.
 * @param {{ prompt?: string, title?: string, slide_context?: string, question_type?: string }} payload
 * @returns {Promise<{ question_content: string, title: string, difficulty: string, answers: Array<{ answer_text: string, is_correct: boolean }> }>}
 */
export const generateQuestionCall = (payload) =>
  CallAPI({
    url: aiGenerateQuestionURL,
    method: "POST",
    body: {
      prompt: payload.prompt || "",
      title: payload.title || "",
      slide_context: payload.slide_context || "",
      question_type: payload.question_type || "text_only",
    },
  });
